import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusFrame12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPlusFrame12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.5.5V3h10v-.5a.5.5 0 0 0-.5-.5m.5 2H1v5.786a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM1.5 1A1.5 1.5 0 0 0 0 2.5v7.286a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V2.5A1.5 1.5 0 0 0 10.5 1zm5.018 4.5a.5.5 0 0 0-1 0v1.268H4.25a.5.5 0 0 0 0 1h1.268V9a.5.5 0 0 0 1 0V7.768H7.75a.5.5 0 0 0 0-1H6.518z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlusFrame12);
